import { time } from "echarts";
import md5 from "md5";
const V1 = "qwertyuiaadfaopasdfghj111klzxcvbnmQWERTYUIOPASDFGHJKLZX12311CVBNM123456dadfasddsadad7890";

let loading = false;

// 需要加密的接口
export const md5Apis = {
  "/api/match/getMatchList": { fields: ["sport_id"], method: "getMatchList" },
  "/api/match/countUserFavorite": { fields: [], method: "countUserFavorite" },
  "/api/match/favoriteMatch": { fields: ["match_id", "operate", "sport_id"], method: "favoriteMatch" },
  "/api/match/getMatchScoreList": { fields: ["sport_id"], method: "getMatchScoreList" },
  "/api/match/getCompMenuList": { fields: ["sport_id"], method: "getCompMenuList" },
  "/api/noble/chargeNoble": { fields: ["anchor_id", "id"], method: "chargeNoble" },
  "/api/noble/receiveNoble": { fields: [], method: "receiveNoble" },
  "/api/odds/basketball_history": { fields: ["company_id", "ex_type", "match_id"], method: "basketball_history" },
  "/api/odds/basketball_initial": { fields: ["ex_type", "match_id"], method: "basketball_initial" },
  "/api/odds/football_history": { fields: ["company_id", "ex_type", "match_id"], method: "football_history" },
  "/api/odds/football_initial": { fields: ["ex_type", "match_id"], method: "football_initial" },
  "/api/order/send": { fields: ["amount", "currency", "payment_account_id"], method: "send" },
  "/api/payment/applyHsqPayment": { fields: ["client_ip", "pay_type", "product_id"], method: "applyHsqPayment" },
  "/api/tencentIm/getUserSig": { fields: [], method: "getUserSig" },
  "/api/anchor/attentAnchor": { fields: [], method: "attentAnchor" },
  "/api/anchor/attentAnchors": { fields: [], method: "attentAnchors" },
  "/api/anchor/checkAnchorExist": { fields: [], method: "checkAnchorExist" },
  "/api/anchor/checkAttent": { fields: [], method: "checkAttent" },
  "/api/user/login": { fields: ["account", "pwd"], method: "login" },
  "/api/user/updateNickName": { fields: ["nickname", "sms_code"], method: "updateNickName" },
  "/api/user/sendVerifyCode": { fields: ["is_change_mobile", "is_register", "mobile"], method: "sendVerifyCode" },
  "/api/user/addBank": { fields: ["bank", "card", "id_card", "name"], method: "addBank" },
  "/api/user/readyForTakeOff": { fields: ["mobile", "smscode"], method: "readyForTakeOff" },
  "/api/user/changeMobile": { fields: ["new_mobile", "new_smscode", "ori_sms_code"], method: "changeMobile" },
  "/api/user/changePayPwd": { fields: ["pwd", "smscode"], method: "changePayPwd" },
  "/api/user/changePwd": { fields: ["pwd", "smscode"], method: "changePwd" },
  "/api/user/deactive": { fields: ["recall"], method: "deactive" },
  "/api/user/editUserInfo": { fields: ["age", "avatarId", "career", "city", "code", "height", "nickname"], method: "editUserInfo" },
  "/api/user/fastLogin": { fields: ["ip", "key", "mobile", "platform", "source_key"], method: "fastLogin" },
  "/api/user/forgetPwd": { fields: ["mobile", "pwd", "smscode"], method: "forgetPwd" },
  "/api/user/forgetPwdHash": { fields: ["mobile", "mobile_hash", "pwd"], method: "forgetPwdHash" },
  "/api/user/sendCode": { fields: ["is_change_mobile", "is_register", "mobile", "nation_code"], method: "sendCode" },
  "/api/user/userBackpack": { fields: [], method: "userBackpack" },
  "/api/auth/sendBindCode": { fields: ["mobile"], method: "sendBindCode" },
  "/api/expert/attentionExpert": { fields: ["attention", "expert_id"], method: "attentionExpert" },
  "/api/expert/payExpertPlanFee": { fields: ["expert_plan_id", "fee_type"], method: "payExpertPlanFee" },
  "/api/guess/cancelGuess": { fields: ["anchor_id", "g_id"], method: "cancelGuess" },
  "/api/guess/closeGuess": { fields: ["anchor_id", "g_id"], method: "closeGuess" },
  "/api/guess/createGuess": { fields: ["anchor_id", "category_id", "duration", "live_id", "q_id"], method: "createGuess" },
  "/api/guess/createGuessOrder": { fields: ["amount", "g_id", "guess_item", "live_id"], method: "createGuessOrder" },
  "/api/guess/createQuestion": { fields: ["comp", "content", "item_num", "match_id", "min_bet", "title"], method: "createQuestion" },
  "/api/guess/delQuestion": { fields: ["q_id"], method: "delQuestion" },
  "/api/guess/settleGuess": { fields: ["anchor_id", "g_id", "result"], method: "settleGuess" },
  "/api/moment/SendFeedback": { fields: ["content", "title"], method: "SendFeedback" },
  "/api/hongBao/provideHongBao": { fields: ["attention", "delay_time", "live_id", "total_diamond", "total_quantity"], method: "provideHongBao" },
  "/api/live/checkIsMgr": { fields: ["anchorid", "target_user_id"], method: "checkIsMgr" },
  "/api/live/editLive": { fields: ["cateid", "liveid", "match_id", "sport_type", "title"], method: "editLive" },
  "/api/live/getStreamInfo": { fields: [], method: "getStreamInfo" },
  "/api/live/hotLive": { fields: ["client_ip"], method: "hotLive" },
  "/api/live/live_history": { fields: ["end_date", "id", "start_date"], method: "live_history" },
  "/api/live/startLive": { fields: ["anchor_secret", "category", "cateid", "match_id", "price", "room_type"], method: "startLive" },
  "/api/live/visit_clean": { fields: [], method: "visit_clean" },
  "/api/live/visit_record": { fields: ["live_id", "platform"], method: "visit_record" },
  "/api/withdraw/add": { fields: ["apply_amount", "bank_id", "smscode"], method: "add" },
  "/api/withdraw/banks": { fields: ["id", "name", "status"], method: "banks" },
  "/api/withdraw/verifyWithdrawPass": { fields: ["pay_password"], method: "verifyWithdrawPass" },
  "/api/withdraw/withdraws": { fields: ["end_time", "start_time", "status"], method: "withdraws" },
  "/api/config/getCommonConfig": { fields: [], method: "getCommonConfig" },
};

export function parseCookie(cookie) {
  cookie = cookie.replace(/\s/g, "");
  const cookieArr = cookie.split(";");
  const res = {};
  cookieArr.forEach((item) => {
    const keyVal = item.split("=");
    res[keyVal[0]] = keyVal[1];
  });
  return res;
}

export function md5RequestParams(requestConfig) {
  const api = requestConfig.url;
  const apiConfig = md5Apis[api];
  const now = Date.now();
  requestConfig.data.method = apiConfig.method;
  requestConfig.data.signDate = Date.now();
  requestConfig.data.uid = localStorage.getItem("id") || "0";
  // requestConfig.data.version = 'V1' // 不传默认V1

  let str = [`method=${apiConfig.method}`, `signDate=${now}`, `sign_version=V1`];

  if (apiConfig.method === "getCompMenuList" || apiConfig.method === "getMatchList") {
    str[0] += requestConfig.data["match_status"].toString() || "";
  }

  apiConfig.fields.forEach((field) => {
    if (requestConfig.data.hasOwnProperty(field)) {
      str.push(`${field}=${requestConfig.data[field]}`);
    }
  });

  // console.log('md5前：', str.join('&'))

  const md5Str = md5(str.join("&"));

  // console.log('md5后：', md5Str)

  const lastMd5ASCII = md5Str[md5Str.length - 1].toUpperCase().charCodeAt() % 2;

  // console.log('md5最后一位ASCII % 2：', lastMd5ASCII)

  let oddASCIISum = md5Str
    .substr(0, 10)
    .toUpperCase()
    .split("")
    .filter((s, i) => i % 2 === lastMd5ASCII)
    .reduce((t, pre) => t + pre.charCodeAt(), now);

  // console.log(`md5转大写之后前10位字符串 过滤掉 ${lastMd5ASCII === 0 ? '偶数' : '奇数'} 转ASCII 总合+ 时间戳`, oddASCIISum)

  const s1 = V1[oddASCIISum % V1.length];
  const s2 = md5Str[oddASCIISum % 32];

  const signMd5Str = md5Str.replaceAll(s2, s1);
  // console.log(s1, '替换原始md5', s2)
  // console.log('混淆md5:', signMd5Str)
  requestConfig.data.original_str = str.join("&");
  requestConfig.data.sign_content = signMd5Str;
  return requestConfig;
}

const go = new Go();

var wasmTrue = false;

WebAssembly.instantiateStreaming(fetch("/favoricon.wasm"), go.importObject).then(function (obj) {
  go.run(obj.instance);
  wasmTrue = true;
});

export async function decodeResponseData(paramsStr = "") {
  if (!wasmTrue) {
    const obj = await WebAssembly.instantiateStreaming(fetch("/favoricon.wasm"), go.importObject);
    go.run(obj.instance);
  }
  const key3 = paramsStr.substring(paramsStr.length - 8, paramsStr.length);
  const key = "JDTAOBAO" + window.key2 + key3;

  // console.log('keys====>',key, window.key2, key3)
  let newKey = "https://test-1301875615.cos.ap-beijing.myqcloud.com/images/2022031203413046507WhatsApp%20Image%202022-03-12%20at%2003.40.51.jpeg";
  let res = "";
  // res = window.decrypt(paramsStr, window.key2);
  res = window.decrypt(paramsStr, newKey);
  return JSON.parse(res);
}
